import { useSyncExternalStore } from "react";

// Tracks the on-screen height of the SoftPhone call card (0 when no call) so
// other bottom-right floating UI, like the assistant launcher, can move above it.

let cardHeight = 0;
const listeners = new Set<() => void>();

export function setSoftPhoneHeight(h: number) {
  const next = Math.max(0, Math.round(h));
  if (next === cardHeight) return;
  cardHeight = next;
  listeners.forEach((l) => l());
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function useSoftPhoneHeight(): number {
  return useSyncExternalStore(subscribe, () => cardHeight, () => 0);
}
